import styled from 'styled-components';

import { basicCaptionSmallTextStyle, Text } from '@dreryk/react-components';

export const StyledText = styled(Text)`
   ${basicCaptionSmallTextStyle};
`;

StyledText.displayName = 'StyledText';
